import {
  DomainSessionId,
  HealthcareUserId,
  ProductType,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export enum SaveActionDtoActionType {
  FAST_TRACK = 1,
  LEAD_SUBMITTED = 3,
  EXTERNAL_REDIRECT = 4,
}

export const SaveActionRequestDto = z.object({
  user_id: HealthcareUserId,
  product: ProductType,
  action_type_id: z.nativeEnum(SaveActionDtoActionType),
  domain_session_id: DomainSessionId,
});

export type SaveActionRequestDto = z.infer<typeof SaveActionRequestDto>;

export const SaveActionResponseDto = z.undefined();

export type SaveActionResponseDto = z.infer<typeof SaveActionResponseDto>;
